import { HubSectionType } from 'utils/gloo-types';
import Typography from 'components/atoms/Typography';
import { ActionType, SplitSectionSide } from 'pages/_AdminAuthoringPages/AdminHubAuthoring/action';
import { HubAuthoringContext, HubAuthoringDispatchContext } from 'pages/_AdminAuthoringPages/AdminHubAuthoring/reducer';
import { useContext, ReactNode } from 'react';
import { CompactPicker } from 'react-color';

interface HubSectionColorSettingsProps {
  index: number;
}

const HubSectionColorSettings = ({ index }: HubSectionColorSettingsProps) => {
  const {
    hubUpsertParams: { sections },
  } = useContext(HubAuthoringContext);
  const dispatch = useContext(HubAuthoringDispatchContext);
  const section = sections[index];

  let textColorControls: ReactNode;
  switch (section.type) {
    case HubSectionType.SPLIT:
      textColorControls = (
        <div>
          {section.a.type === 'text' && (
            <div>
              <Typography className="text-sm text-glooCharcoal font-semibold pb-2 pt-5" variant="base">
                Section Left Text Color
              </Typography>
              <CompactPicker
                color={section.a.textColor || '#000'}
                onChange={(color) => {
                  dispatch({
                    type: ActionType.setSplitSectionTextColor,
                    payload: {
                      index,
                      side: SplitSectionSide.LEFT,
                      textColor: color.hex,
                    },
                  });
                }}
              />
            </div>
          )}
          {section.b.type === 'text' && (
            <div>
              <Typography className="text-sm text-glooCharcoal font-semibold pb-2 pt-5" variant="base">
                Section Right Text Color
              </Typography>
              <CompactPicker
                color={section.b.textColor || '#000'}
                onChange={(color) => {
                  dispatch({
                    type: ActionType.setSplitSectionTextColor,
                    payload: {
                      index,
                      side: SplitSectionSide.RIGHT,
                      textColor: color.hex,
                    },
                  });
                }}
              />
            </div>
          )}
        </div>
      );
      break;
    case HubSectionType.TEXT:
      textColorControls = (
        <div>
          <Typography className="text-sm text-glooCharcoal font-semibold pb-2 pt-5" variant="base">
            Section Text Color
          </Typography>
          <CompactPicker
            color={section.textColor || '#000'}
            onChange={(color) => {
              dispatch({
                type: ActionType.setSectionTextColor,
                payload: {
                  index,
                  textColor: color.hex,
                },
              });
            }}
          />
        </div>
      );
      break;
    default:
      textColorControls = null;
      break;
  }

  return (
    <div>
      <Typography className="text-sm text-glooCharcoal font-semibold pb-2 pt-2" variant="base">
        Background Color
      </Typography>
      <CompactPicker
        color={section.backgroundColor || '#FFF'}
        onChange={(color) => {
          dispatch({
            type: ActionType.setSectionBackgroundColor,
            payload: {
              index,
              backgroundColor: color.hex,
            },
          });
        }}
      />
      <Typography className="text-sm text-glooCharcoal font-semibold pb-2 pt-5" variant="base">
        Section Title Text Color
      </Typography>
      <CompactPicker
        color={section.titleColor || '#000'}
        onChange={(color) => {
          dispatch({
            type: ActionType.setSectionTitleColor,
            payload: {
              index,
              titleColor: color.hex,
            },
          });
        }}
      />
      <Typography className="text-sm text-glooCharcoal font-semibold pb-2 pt-5" variant="base">
        Section Description Text Color
      </Typography>
      <CompactPicker
        color={section.descriptionColor || '#000'}
        onChange={(color) => {
          dispatch({
            type: ActionType.setSectionDescriptionColor,
            payload: {
              index,
              descriptionColor: color.hex,
            },
          });
        }}
      />
      {textColorControls}
    </div>
  );
};

export default HubSectionColorSettings;
